





























import { Component } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunityLostReasons from '@/components/OpportunityLostReasons/OpportunityLostReasons.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';

@Component({
	name: 'AgencyOpportunityLostReasonSettings',
  	components: { OpportunityLostReasons, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getOpportunityLostReasons();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingOpportunityLostReasons;
  	}
}
